/**
 * @typedef {'draft' | 'published' | 'running' | 'closed' | 'archived'} CompetitionStatus
 */

/**
 * @typedef {Object} CompetitionMeta
 * @property {string} competitionId
 * @property {string} competitionKind Opaque consumer kind, e.g. room_session
 * @property {string} policyBundleId
 * @property {number} policyBundleVersion
 * @property {CompetitionStatus} status
 * @property {Record<string, unknown>} externalRefs e.g. { roomCode }
 * @property {Record<string, unknown>} [metadata]
 */

export function newCompetitionId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `cmp_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}
